export enum FormDisplayMode {
  READ_ONLY = "readonly",
  EDIT = "edit",
}
